"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavDrawerCtrl = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const page_registry_1 = require("../../page/page.registry");
const services_1 = require("../../services");
class NavDrawerCtrl {
    constructor() {
        this.visible = false;
    }
    get entries() {
        const entries = [];
        for (const { config } of page_registry_1.PageRegistry.pages) {
            if (config.nav == null) {
                continue;
            }
            const currentUser = services_1.Services.User.current;
            const userProfile = currentUser ? services_1.Services.UserProfile.get(currentUser.objectId) : null;
            if ((config.auth.tokens == null || services_1.Services.Token.hasAll(config.auth.tokens)) &&
                (config.auth.userLevel == null || services_1.Services.UserProfile.isOneOf(userProfile, config.auth.userLevel))) {
                entries.push({
                    type: config.type,
                    title: config.nav.name,
                    icon: config.nav.icon,
                    name: config.name,
                    current: services_1.Services.Route.active.config.name === config.name,
                });
            }
        }
        return entries;
    }
    get username() {
        const user = services_1.Services.User.current;
        if (user != null) {
            return services_1.Services.User.current.username;
        }
        return '';
    }
    setVisible(visible) {
        this.visible = visible;
    }
}
exports.NavDrawerCtrl = NavDrawerCtrl;
tslib_1.__decorate([
    mobx_1.observable
], NavDrawerCtrl.prototype, "visible", void 0);
tslib_1.__decorate([
    mobx_1.computed
], NavDrawerCtrl.prototype, "entries", null);
tslib_1.__decorate([
    mobx_1.computed
], NavDrawerCtrl.prototype, "username", null);
tslib_1.__decorate([
    mobx_1.action
], NavDrawerCtrl.prototype, "setVisible", null);
//# sourceMappingURL=nav.drawer.ctrl.js.map